import { render } from "./Tyre.vue?vue&type=template&id=72b6cb13"
import script from "./Tyre.vue?vue&type=script&lang=js"
export * from "./Tyre.vue?vue&type=script&lang=js"

import "./Tyre.vue?vue&type=style&index=0&id=72b6cb13&lang=scss"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__